export default __webpack_public_path__ + "static/media/project_1.c36b28ea.jpg";